import resourceService from "./resource.service";
import baseService from "./base.service";
import axios from 'axios';

const path = 'admin/users'
const service = resourceService.init(path)


service.changePassword = (id, newPassword)=>{
    return baseService.request(axios.post(`admin/users/${id}`, {
        password : newPassword
    }))
}


export default service
